import simpleParallax from "simple-parallax-js";

const parallaxImages = document.querySelectorAll(".parallax-img img");
new simpleParallax(parallaxImages, {
  delay: 2,
  transition: "cubic-bezier(0,0,0,1)",
});
